import type { MutateOptions } from "@tanstack/react-query";
import { useCurrentStateAndParams } from "@uirouter/react";
import { translate } from "app/filters/i18nFilter";
import EmailUnsubscribeModal from "app/pages/sales-intelligence/common-components/EmailUnsubscribeModal/EmailUnsubscribeModal";
import type {
    DigestSubscription,
    UpdateDigestSubscriptionDTO,
} from "app/pages/sales-intelligence/sub-modules/signals-alerts/models/DigestSubscription";
import { getSubscriptionParams } from "app/pages/sales-intelligence/utils/routing";
import { useEffect, useState } from "react";

type Props = {
    isLoading: boolean;
    onConfirm(dto: UpdateDigestSubscriptionDTO, options: Readonly<MutateOptions<DigestSubscription, unknown, UpdateDigestSubscriptionDTO>>): void;
};

const EmailUnsubscribeModalContainer = ({ isLoading, onConfirm }: Props) => {
    const { params } = useCurrentStateAndParams();

    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const { subscriptionCancelType, digestAssetId, digestAssetType } = getSubscriptionParams(params);

        if (subscriptionCancelType === "signalsDigest" && digestAssetId && digestAssetType) {
            setIsModalOpen(true);
        }
    }, []);

    const handleConfirmUnsubscribe = () => {
        const { digestAssetId, digestAssetType } = getSubscriptionParams(params);

        if (!digestAssetId || !digestAssetType) {
            return;
        }

        onConfirm(
            { assetId: digestAssetId, assetType: digestAssetType, status: "inactive" },
            {
                onSuccess() {
                    setIsModalOpen(false);
                },
            },
        );
    };

    const handleCancelUnsubscribe = () => {
        setIsModalOpen(false);
    };

    return (
        <EmailUnsubscribeModal
            isOpen={isModalOpen}
            isLoading={isLoading}
            title={translate("si.signals.digest.cancel.modal.title")}
            subtitle={translate("si.signals.digest.cancel.modal.subtitle")}
            onConfirm={handleConfirmUnsubscribe}
            onCancel={handleCancelUnsubscribe}
        />
    );
};

export default EmailUnsubscribeModalContainer;
